import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputCity: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="City:">
    {form.getFieldDecorator('city', {
      initialValue,
      rules: [{ message: 'Please enter the location city.', required: true }],
    })(<Input allowClear placeholder="City" />)}
  </Form.Item>
);
